module.exports = __webpack_public_path__ + "static/auth0-image-fit-scale-down-7fc9072a76dd87c313e7a43f559ee8ec.png";